<template>
    <div class="v-filter">

        <slot></slot>

        <div class="v-filter__tabs">
            <div class="v-filter__container">
                <div class="v-filter__table-container">
                    <table class="v-filter__table">
                        <thead>
                        <tr>
                            <td>{{ $t('global.Name') }}</td>
                            <td>{{ $t('global.Total') }}</td>
                            <td>{{ $t('global.Selected') }}</td>
                        </tr>
                        </thead>
                        <tbody>
                        <template
                            v-for="(field, index) of fields"
                        >
                            <tr
                                :key="index"
                                class="v-filter__table-item"
                                :class="{active: field.field === selectTab}"
                                @click="onTab(field)"
                            >
                                <td>{{$t(field.name)}}</td>
                                <td><span>{{(options[field.field] || []).length}}</span></td>
                                <td><span>{{(selected[field.field] || []).length}}</span></td>
                            </tr>
                            <tr style="height: 2px;"></tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="v-filter__line"></div>

            <div class="v-filter__container w-full">
                <div class="pb-2">
                    <input class="v-filter__search" placeholder="Search" v-model="search"/>
                </div>

                <ul class="v-filter__list w-full">
                    <li v-if="!list.length">
                        <no-data />
                    </li>

                    <li v-else
                        v-for="(item, index) of list"
                        :key="index"
                        class="v-filter__item"
                        @click="selectItem(item.id || item)"
                    >
                        <input type="checkbox"
                               class="v-filter__checkbox"
                               :checked="(selected[selectTab] || []).includes(item.id || item)"
                        />

                        <span>{{ item.name || item}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import VDatePicker from "@/components/date-picker/VDatePicker.vue"
import {checkPermission} from '@/utils/mixins'
import vSelect from "vue-select";

export default {
    name: 'v-filter',

    mixins: [checkPermission],

    components: {
        vSelect,
        VDatePicker
    },

    props: {
        fields: {
            type: Array,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            date: [new Date(), new Date()],
            list: [],
            listCopy: [],
            selected: {},
            selectTab: '',
            search: ''
        }
    },

    watch: {
        search(value) {
            this.list = this.searchItems(this.escapeRegExp(value))
        }
    },

    methods: {
        escapeRegExp(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        },

        copy(data) {
            return JSON.parse(JSON.stringify(data))
        },

        setTab(event) {
            this.selectTab = event
        },

        onTab(data) {
            this.setTab(data.field)

            this.list = this.options[data.field] || []

            this.listCopy = this.copy(this.list)
        },

        selectItem(data) {
            if (this.selected[this.selectTab].includes(data)) {
                this.selected[this.selectTab] = this.selected[this.selectTab].filter(item => item !== data)
            } else {
                this.selected[this.selectTab].push(data)
            }
        },

        searchItems(query) {
            const regex = new RegExp(query, 'i')

            return this.listCopy.filter(item => {
                if (typeof item === 'string') {
                    return item.search(regex) !== -1
                } else if (typeof item === 'object' && item !== null) {
                    if (Object.prototype.hasOwnProperty.call(item, 'name')) {
                        return typeof item.name === 'string' && item.name.search(regex) !== -1
                    }
                    return Object.values(item).some(value => typeof value === 'string' && value.search(regex) !== -1)
                }
                return false
            })
        }
    },

    mounted() {
        this.selected = this.fields.reduce((accumulator, {field}) => {
            accumulator[field] = this.selected[field] ? this.selected[field] : []
            return accumulator
        }, {})

        this.onTab(this.fields[0])
    }
}
</script>

<style lang="scss">
.v-filter {
    &__search {
        width: 100%;
        height: 30px;
        padding: 10px;
        border-radius: 6px;
        border: 1px solid #dae1e7;

        &::placeholder {
            color: #9d9d9d;
        }
    }

    &__table {
        width: 100%;
        border-collapse: collapse;

        &-container {
            height: calc(100vh - 345px - 37px);
            overflow: auto;
        }

        thead {
            position: sticky;
            top: 0;
            background-color: #fff;
        }

        td,th {
            padding: 5px;
        }

        span {
            background-color: #f8f8f8;
            padding: 3px 8px;
            border-radius: 6px;
            font-size: 11px;
        }

        &-item {
            cursor: pointer;

            td {
                &:first-child {
                    border-top-left-radius: 6px;
                    border-bottom-left-radius: 6px;
                }

                &:last-child {
                    border-top-right-radius: 6px;
                    border-bottom-right-radius: 6px;
                }
            }

            td, th {
                text-align: center;

                &:first-child {
                    text-align: left;
                }
            }

            &.active {
                background-color: rgba(var(--vs-primary), 1);
                color: white;

                span {
                    color: black;
                }
            }

            &:hover {
                td {
                    background-color: rgba(var(--vs-primary), 1);
                    color: white;

                    span {
                        color: black;
                    }
                }
            }
        }
    }

    &__checkbox {
        width: 20px;
        height: 20px;
        border-radius: 6px;
        border: 1px solid rgba(var(--vs-primary), 1);
        cursor: pointer;
        accent-color:  rgba(var(--vs-primary), 1)
    }

    &__tabs {
        display: flex;
        align-items: start;
    }

    &__container {
        width: 400px;
    }

    &__line {
        width: 2px;
        height: calc(100vh - 345px - 30px);
        background-color: #f8f8f8;
        margin-left: 10px;
        margin-right: 10px;
    }

    &__item {
        display: flex;
        align-items: center;
        padding: 5px 10px;
        cursor: pointer;

        span {
            padding-left: 5px;
        }
    }

    &__list {
        height: calc(100vh - 345px - 30px - 37px);
        overflow: scroll;

        &-item {
            padding: 5px 10px;
            display: flex;
            justify-content: space-between;
            border-radius: 6px;
            cursor: pointer;
            margin-bottom: 3px;

            span {
                &:last-child {
                    background-color: #f8f8f8;
                    border-radius: 6px;
                    color: black;
                    padding: 3px 5px;
                    font-size: 11px;
                }
            }

            &.active {
                background-color: rgba(var(--vs-primary), 1);
                color: white;
            }

            &:hover {
                background-color: rgba(var(--vs-primary), 1);
                color: white;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}
</style>
